import { render, staticRenderFns } from "./AdditionalMetaproperties.vue?vue&type=template&id=40fafc5f&scoped=true"
import script from "./AdditionalMetaproperties.vue?vue&type=script&lang=js"
export * from "./AdditionalMetaproperties.vue?vue&type=script&lang=js"
import style0 from "./AdditionalMetaproperties.vue?vue&type=style&index=0&id=40fafc5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fafc5f",
  null
  
)

export default component.exports